import { all, takeEvery } from 'redux-saga/effects';
import actions from './actions';
import CollectionSagas from '../Collection/sagas';

class Editions extends CollectionSagas {

    constructor() {
        super(actions,'editions');
    }
}

export default function* rootSaga() {
    yield all([
        takeEvery(actions.LOAD_FROM_FIRESTORE, new Editions().loadFromFirestore),
        takeEvery(actions.SAVE_INTO_FIRESTORE, new Editions().storeIntoFirestore),
    ]);
}
